import {MOON_500} from '@wandb/weave/common/css/color.styles';
// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
// @todo: Migrate to 'Tooltip' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Tooltip} from '@wandb/weave/components/Tooltip';
import React from 'react';

import {Analytics} from '../../services/analytics';
import {WBTableRowWithRunSetInfo} from '../../util/tablecols';
import {useFetchRunJob} from '../Launch/hooks';
import {shouldShowLaunchButton} from '../Launch/launchActive';
import {JobInfo} from '../Launch/utilTypes';

interface LaunchJobIconProps {
  projectName: string;
  entityName: string;
  row: WBTableRowWithRunSetInfo;
  setLaunchDrawerRow: (name: string, jobInfo: JobInfo) => void;
  isLaunchActive?: boolean;
  isLaunchPublicQueueActive?: boolean;
}

const trackLaunchIconClicked = ({
  entityName,
  projectName,
  runName,
  jobID,
}: {
  entityName: string;
  projectName: string;
  runName: string;
  jobID: string;
}) => {
  Analytics.track('Runs table launch', {
    entityName,
    projectName,
    runName,
    jobID,
  });
};

const LaunchJobIcon = (props: LaunchJobIconProps) => {
  const {
    projectName,
    entityName,
    row,
    setLaunchDrawerRow,
    isLaunchActive,
    isLaunchPublicQueueActive,
  } = props;

  const {jobInfo, loading, error} = useFetchRunJob({
    entityName,
    projectName,
    runName: row.name,
    skip: false,
  });

  if (loading || error) {
    return <></>;
  }

  return (
    <LaunchJobIconInner
      row={row}
      setLaunchDrawerRow={setLaunchDrawerRow}
      projectName={projectName}
      entityName={entityName}
      jobInfo={jobInfo}
      isLaunchActive={isLaunchActive}
      isLaunchPublicQueueActive={isLaunchPublicQueueActive}
    />
  );
};

interface LaunchJobIconInnerProps {
  row: WBTableRowWithRunSetInfo;
  setLaunchDrawerRow: (name: string, jobInfo: JobInfo) => void;
  projectName: string;
  entityName: string;
  jobInfo: JobInfo | null;
  isLaunchActive?: boolean;
  isLaunchPublicQueueActive?: boolean;
}

const LaunchJobIconInner = (props: LaunchJobIconInnerProps) => {
  const {
    row,
    setLaunchDrawerRow,
    projectName,
    entityName,
    jobInfo,
    isLaunchActive,
    isLaunchPublicQueueActive,
  } = props;

  const shouldShowIcon = shouldShowLaunchButton(
    jobInfo,
    isLaunchActive,
    isLaunchPublicQueueActive
  );

  if (!shouldShowIcon) {
    return <></>;
  }

  return (
    <div
      className="launch-run-icon"
      style={{
        justifyContent: 'right',
        display: 'flex',
        flex: 1,
      }}>
      <Tooltip
        position="top left"
        trigger={
          <span>
            <Button
              data-test="launch-icon"
              disabled={jobInfo == null}
              icon="play"
              variant="ghost"
              style={{color: MOON_500}}
              onClick={() => {
                if (jobInfo != null) {
                  trackLaunchIconClicked({
                    entityName,
                    projectName,
                    runName: row.name,
                    jobID: jobInfo.id,
                  });
                  setLaunchDrawerRow(row.name, jobInfo);
                }
              }}
            />
          </span>
        }>
        <div>Rerun with launch</div>
      </Tooltip>
    </div>
  );
};

export default LaunchJobIcon;
